import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
const md5 = require('md5-jkmyers'); // claims to be the fastest

import VoiceStore from '../../../stores/VoiceStore';
import VoiceActions from '../../../actions/VoiceActions';

const propTypes = {
    rich_text_id: PropTypes.string.isRequired,
    playStore: PropTypes.object.isRequired,
    rollParams: PropTypes.object.isRequired,
    coachVariables: PropTypes.object.isRequired,
    onMountChange: PropTypes.func,
    onFinish: PropTypes.func,
}

// This component is shown when playing a course and the flow map of a course is displayed
class VoiceAudioArray extends React.Component {
    constructor(props) {
        super(props);
        let storeState = VoiceStore.getState();
        let { volume, disabled } = storeState.options;
        let shouldPlay = !storeState.voiceElement.paused;
        let audio_index = 0;
        let audio_count = props.playStore.getVoiceElementCountForRichText(props.rich_text_id);
        let audio_src = shouldPlay ? props.playStore.getVoiceElement(props.rich_text_id,audio_index, props.coachVariables, props.rollParams) : '';
        let audio_key = audio_src ? md5(audio_src) : "blank";
        
        this.state = {
            volume, disabled,
            rich_text_id: props.rich_text_id, //   added so that getDerivedStateFromProps could replace UNSAFE_componentWillReceiveProps
            audio_count,
            audio_index,
            audio_src,
            audio_key,
            init_time: Date.now(),
            shouldPlay
        };
        if (!audio_src && shouldPlay) {
            setTimeout(this.nextAudio,0); // skip first blank
        }
        this.unsubscribes = [VoiceStore.listen(this.onVoiceStoreChange)];
    }
    
    componentDidMount() {
        //VoiceActions.setVoiceElementMounted(true);
        this.updateElementVolume();
        //if (this.state.audio_src) {
        //    VoiceActions.setVoiceElementStartStop(uuid.v4(),{start:true});
        //}
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateElementVolume();
        //if (this.state.audio_src && !prevState.audio_src) {
        //    VoiceActions.setVoiceElementStartStop({start:true});
        //}
        //else if ((prevProps.rich_text_id !== this.props.rich_text_id) && this.state.audio_src) {
        //    VoiceActions.setVoiceElementStartStop(uuid.v4(),{start:true}); // new coach chat node
        //}
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        //VoiceActions.setVoiceElementMounted(false);
    }

    updateElementVolume=()=>{
        var audioElement = ReactDOM.findDOMNode(this.refs.audio_control);
        if (audioElement) {
            let volume = (this.state.volume / 100); // should be 0 to 1
            if (!isNaN(volume)) {
                audioElement.volume = volume; 
            }
        }
    }
    
    onVoiceStoreChange=(storeState)=>{
        if (storeState.action.type === 'setVoiceElementPlay') {
            var audioElement = ReactDOM.findDOMNode(this.refs.audio_control);
            if (audioElement) {
                audioElement.pause();
                audioElement.currentTime = 0;
            }
            let shouldPlay = !storeState.voiceElement.paused;
            if (this.state.shouldPlay !== shouldPlay) {
                this.setState({shouldPlay});
            }
            if (shouldPlay) {
                const props = this.props;
                const audio_index = 0;
                let audio_src = props.playStore.getVoiceElement(props.rich_text_id,audio_index, props.coachVariables, props.rollParams);
                let audio_key = audio_src ? md5(audio_src) : "blank";
                if (audioElement && (audio_src === this.state.audio_src)) {
                    audioElement.play(0);
                    //VoiceActions.setVoiceElementStartStop({start:true});
                }
                else {
                    this.setState({audio_index,audio_key,audio_src});
                }
            }
            //else {
            //     VoiceActions.setVoiceElementStartStop({stop:true});
            //}
        }
        else {
            const { options } = storeState;
            let { volume, disabled } = options;
            if ((volume != this.state.volume) || (disabled !== this.state.disabled)) {
                // console.log(`VoiceAudioArray store volume:${volume}, disabled:${disabled}`);
                this.setState({volume,disabled},()=>{
                    this.updateElementVolume();
                });
            }
        }
    }
    
    static getDerivedStateFromProps(nextProps, prevState){
        if(nextProps.rich_text_id!==prevState.rich_text_id){
            let audio_index = 0;
            let audio_count = nextProps.playStore.getVoiceElementCountForRichText(nextProps.rich_text_id);
            let audio_src = nextProps.playStore.getVoiceElement(nextProps.rich_text_id,audio_index,nextProps.coachVariables, nextProps.rollParams);
            let audio_key = audio_src ? md5(audio_src) : "blank";
            return {
                rich_text_id: nextProps.rich_text_id,
                audio_count,
                audio_index,
                audio_src,
                audio_key,
                init_time: Date.now(),
            };
        }
        return null;
    }
    
    nextAudio=()=>{
        if (this.state.disabled || !this.state.shouldPlay) { 
            return;
        }
        let audio_index = this.state.audio_index + 1;
        if (audio_index < this.state.audio_count) {
            let audio_src = this.props.playStore.getVoiceElement(this.props.rich_text_id,audio_index,this.props.coachVariables, this.props.rollParams);
            let audio_key = audio_src ? md5(audio_src) : this.state.audio_key;
            this.setState({
                audio_index,
                audio_src,
                audio_key,
            },()=>{
                if (!audio_src) {
                    console.log("nextAudio advancing past blank",this.props.rich_text_id, audio_index); // FIXME: remove debug spam
                    setTimeout(this.nextAudio,0);
                }
            });
        }
        else {
            let elapsed = Date.now() - this.state.init_time;

//            console.log("VoiceAudioArray onFinish called with");
//            console.log(`props rich_text_id ${this.props.rich_text_id}`);
//            console.log(`state rich_text_id ${this.state.rich_text_id}`);
//            console.log(`audio_index ${audio_index}`); 
//            console.log(`elapsed ${elapsed}`); 

            if (this.props.onFinish) {
                // VoiceActions.setVoiceElementStartStop({stop:true});
                this.props.onFinish();
            }
        }
    }

    render() {
        if (this.state.disabled || !this.state.shouldPlay) { 
            return null;
        }
        return (
            <audio ref="audio_control" className="voice-audio-player" key={this.state.audio_key} src={this.state.audio_src} onEnded={this.nextAudio} autoPlay/>
        );
    }
};

VoiceAudioArray.propTypes = propTypes;

export default VoiceAudioArray;